import { MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react'
import { createCategory, deleteCategory, getCategory, logEvent } from '../../services/classApiServices';
import Loader from '../../components/Loader';
import { browserName, browserVersion } from "react-device-detect";
import { useAnalytics } from '../../hooks/useAnalytics';


function ClassCategory(props) {
    const { trackButtonClick } = useAnalytics();
    const [basicData, setBasicData] = useState({
        columns: [],
        rows: [],
    });
    const [loading, setLoading] = useState(false)
    const [classCategory, setClassCategory] = useState([])
    const [centredModal, setCentredModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [newCategoryName, setNewCategoryName] = useState('');
    const [categoryToDelete, setCategoryToDelete] = useState(null);
    const [refresh, setRefresh] = useState(false)
    const toggleOpen = () => setCentredModal(!centredModal);
    const [editId, setEditId] = useState(null);
    const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
    const isAdmin = loggedUserInfo?.role !== "staff";
    useEffect(() => {

        async function fetchData() {
            if (localStorage.getItem("loggedUserInfo")) {
                const response = await getCategory(
                    JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                );
                if (!response) {
                    return;
                }
                if (response === "false") {
                    // setApiError(true)
                } else {
                    const tempData = await response.json();


                    setClassCategory(tempData);

                }
                setRefresh(false)
            }
        }


        fetchData();

    }, [refresh]);

    function openEditForm(e, data) {
        setEditId(data._id);
        setNewCategoryName(data.name)
        setCentredModal(true);
    }

    function openDeleteModal(e, item) {
        setCategoryToDelete(item);
        setDeleteModal(true);
    }

    async function confirmDelete() {
        if (!categoryToDelete) return;

        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
        const fullName = userInfo?.name || `${userInfo?.fname || ""} ${userInfo?.lname || ""}`.trim() || "User";
        const username1 = userInfo.email || "Guest";
        const gymid = userInfo.gymid || "";
        const ip = localStorage.getItem("ipaddress");
        const browserinfo = `${browserName}-${browserVersion}.0.0`;

        const categoryName = categoryToDelete?.name || "Category";

        try {
            setLoading(true);

            // Perform deletion
            await deleteCategory(gymid, categoryToDelete);

            // Logging the deletion
            setRefresh(true);
            setDeleteModal(false);

            const flag = `${categoryName} Category deleted successfully${fullName}`;
            props.showAlert(flag);

            await logEvent(
                {
                    Eventtype: username1,
                    username1,
                    fullName,
                    ip,
                    flag,
                    browserinfo,
                    gymid,
                    isclass: true
                },
                gymid
            );
            await trackButtonClick("ClassCategory", "Delete_ClassCategory", "staff", {});

        } catch (err) {
            console.error("Delete failed", err);
        } finally {
            setLoading(false);
        }
    }

    async function handleCreateCategory(e) {
        e.preventDefault();
        const user = JSON.parse(localStorage.getItem("loggedUserInfo"));
        if (!newCategoryName.trim() || !user?.gymid) return;

        try {
            setLoading(true);

            // Capture previous name if editing
            let previousName = "";
            if (editId != null && Array.isArray(classCategory)) {
                const existingCategory = classCategory.find(cat => cat._id === editId);
                previousName = existingCategory?.name || "";
            }

            const response = await createCategory(user.gymid, {
                name: newCategoryName,
                bid: user.gymid,
                _id: editId != null ? editId : -1
            });

            const result = await response.json();

            const fullName = user?.name || `${user?.fname || ""} ${user?.lname || ""}`.trim() || "User";
            const username1 = user.email || "Guest";
            const ip = localStorage.getItem("ipaddress");
            const browserinfo = `${browserName}-${browserVersion}.0.0`;
            const gymid = user.gymid;

            const flag = editId != null
                ? `Category "${previousName}" updated sucessfully to (${newCategoryName}) `
                : `Category "${newCategoryName}"created by (${fullName})`;

            props.showAlert(flag);

            await trackButtonClick("ClassCategory", editId != null ? "Update_ClassCategory" : "Created_ClassCategory", "staff", {});
            setRefresh(true);
            setNewCategoryName('');
            setCentredModal(false);



            await logEvent({
                Eventtype: username1,
                username1,
                fullName,
                ip,
                flag,
                browserinfo,
                gymid,
                isclass: true
            }, gymid);

        } catch (error) {
            console.error("Error creating/updating category", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {


        const popupRow = [];
        let snumber = 1

        classCategory && classCategory.length > 0 && classCategory.forEach((item, index) => {

            const rarray = [];

            rarray.push(snumber++)
            rarray.push(item.name);
            const editIcon = (
                <MDBIcon
                    fas
                    icon="edit"
                    className="fs-6 ps-2"
                    onClick={(e) => isAdmin ? openEditForm(e, item) : undefined}
                />
            );

            const deleteIcon = (
                <MDBIcon
                    fas
                    icon="trash"
                    className="fs-6 ps-2"
                    onClick={(e) => isAdmin ? openDeleteModal(e, item._id) : undefined}
                />
            );

            rarray.push(
                <>
                    <span className="ml0">
                        {editIcon}
                    </span>
                    <span href="#" className="ml20">
                        {deleteIcon}
                    </span>
                </>
            );

            popupRow.push(rarray);


        })

        setBasicData({
            columns: ["S.no", 'Name', "Action"],
            rows: popupRow
        })
    }, [classCategory])


    const handlePopupCategory = () => {
        setNewCategoryName("")
        toggleOpen()
    }

    return (
        <div>
            <div className='position-relative'>
                <div className='actionbar mob-actionbar'>
                    {(localStorage.getItem("loggedUserInfo")) && JSON.parse(localStorage.getItem("loggedUserInfo")).role === "admin" &&
                        <>  <MDBBtn color='success' className='text-capitalize' onClick={handlePopupCategory}>
                            <MDBIcon fas icon="plus" className="me-2" />
                            Add New Category
                        </MDBBtn></>}
                </div>
                <div className="trainerSummeryDataTable classcategory-search mt-3 mob-trainer">
                    {loading ? (<div className="loader-height"> <Loader /></div>) : <>
                        <MDBDatatable entries={25} className="sortOff" search paging={true} data={basicData} /></>}

                </div>
            </div>

            <MDBModal tabIndex='-1' open={centredModal} onClose={() => setCentredModal(false)}>
                <MDBModalDialog centered size='md'>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Create Class Category</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <form onSubmit={handleCreateCategory}>
                                <MDBInput
                                    label='Category Name'
                                    value={newCategoryName}
                                    onChange={(e) => setNewCategoryName(e.target.value)}
                                    required
                                />
                                <div className='mt-3 d-flex justify-content-end'>
                                    <MDBBtn type='submit'>{editId != null ? "Save" : "Create"}</MDBBtn>
                                </div>
                            </form>
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            {/* Delete Confirmation Modal */}
            <MDBModal tabIndex="-1" open={deleteModal} onClose={() => setDeleteModal(false)}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Confirm Deletion</MDBModalTitle>
                            <MDBBtn className="btn-close" color="none" onClick={() => setDeleteModal(false)}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <p>Are you sure you want to delete this class category?</p>
                        </MDBModalBody>
                        <MDBModalFooter className='pe-2 pb-2'>
                            <MDBBtn color="secondary" onClick={() => setDeleteModal(false)}>
                                Cancel
                            </MDBBtn>
                            <MDBBtn color="danger" onClick={confirmDelete}>
                                Delete
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </div>
    )
}

export default ClassCategory
